var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"image-editor__loading"},[_c('bucket-loading'),_c('p',{staticClass:"image-editor__loading-msg"},[_vm._v(_vm._s(_vm.texts[_vm.i % _vm.texts.length]))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }